import $ from 'jquery';
import React, {
    Fragment, useState, useRef, useEffect, useContext,
} from 'react';
import Tippy from '@tippyjs/react';
import { createPortal } from 'react-dom';
import moment from 'moment';

import Select from 'react-select';
import { PageContext } from '../../context/PageContext';
import useUsers from '../../hooks/useUsers';

import getParamsFromSearchURL from '../../utilities/getParamsFromSearchURL';
import {
    getApiCreatePageVerificationSchedule, getApiGetVerificationAssigneesUrl,
    getApiPageVerificationSchedule,
    getUpgradePlanUrl,
    getApiUpdatePageVerificationSchedule,
} from '../../utilities/urlHelper';
import {
    canCreateVerificationSchedule,
    canDeleteVerificationSchedule,
    canUpdateVerificationSchedule,
    canViewVerificationSchedule,
} from '../../utilities/permissionsUtilities';
import { hasVerificationFeature } from '../../utilities/featureHelper';
import { addSuccessMessage } from '../../utilities/notificationUtilities';
import { VerificationListContext } from '../analytics/VerificationList';
import { USER_ROLE } from '../../utilities/CONSTANTS';
import { pluralText } from '../../utilities/wordUtilities';

const clickReassignPage = (e) => {
    e.preventDefault();
    return $('#change-page-owner-modal').click();
};

const VerificationAssignee = ({ page }) => {
    let assignees;
    const [assigneesArr, setAssigneesArr] = useState();
    const users = useUsers();
    const url = getApiGetVerificationAssigneesUrl(page.id);

    useEffect(() => {
        $.get(url)
            .then(({ assignees }) => {
                setAssigneesArr(assignees);
            });
    }, [url]);
    if (assigneesArr) {
        assignees = users && users.filter(u => (assigneesArr.includes(u.id)));
    }
    return (
        <Fragment>
            <label className="bold block col-12 mb1">Assignee(s)</label>
            {!assignees
                ? (<span className="loading grey">Loading</span>)
                : assignees.map((element, index, array) => (
                    <div key={index} className="block col-12 mb2">
                        <div className="flex">
                            <img className="post-avatar mr1 flex-none" src={element.image_192} width="32" height="32" />
                            <span className="flex-auto elipsis">
                                {element.display_name}
                                {' '}
                            </span>
                        </div>
                    </div>
                ))}

        </Fragment>
    );
};

const SelectVerificationAssignees = (props) => {
    const users = useUsers();
    const options = users && users.filter(u => u.id > 0 && [USER_ROLE.ADMIN, USER_ROLE.EDITOR, USER_ROLE.CONTRIBUTOR].includes(u.role)).map(user => ({ label: user.display_name, value: user.id }));
    const handleChange = (assignees) => {
        props.onAssigneeSelect(assignees);
    };
    return (
        <Fragment>
            <label className="bold block col-12 mb1">Assignee(s)</label>
            <div className="block col-12 mb2">
                {!users || (props.verificationScheduleId && !props.assignees)
                    ? (<span className="loading grey">Loading</span>)
                    : (
                        <div className="flex">
                            <Select
                                name="assignees"
                                defaultValue={props.assignees}
                                className="block col-12 field mb2"
                                onChange={handleChange}
                                options={options}
                                isMulti
                            />

                        </div>
                    )}
            </div>
        </Fragment>
    );
};

const VerificationCreator = ({ user_id, created_at }) => {
    const users = useUsers();
    const user = users && users.find(u => (u.id == user_id));
    const createdAtFormatted = moment.utc(created_at).local().format('ll');

    return (
        <Fragment>
            <label className="bold block col-12 mb1 mt2">Created by</label>
            <div className="block col-12 mb2">
                {user
                    ? (
                        <div className="flex">
                            <img className="post-avatar mr1 flex-none" src={user.image_192} width="32" height="32" />
                            <span className="flex-auto elipsis">
                                {user.display_name}
                                <span className="gray ml1">
(
                                    {createdAtFormatted}
)
                                </span>
                            </span>
                        </div>
                    )
                    : (<span className="loading grey">Loading</span>)}
            </div>
        </Fragment>
    );
};

const CreateVerificationScheduleModal = (props) => {
    const descriptionInput = useRef(null);
    const daysInput = useRef(null);
    const [isCreating, setIsCreating] = useState(false);
    const [assignees, setAssignees] = useState(false);

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };
    const handleAssigneeSelect = (list) => {
        setAssignees(list);
    };
    const onClickCreate = () => {
        const description = descriptionInput.current.value;
        const days = daysInput.current.value;
        if (isCreating || !days || parseInt(days) < 1) return;

        setIsCreating(true);

        const url = getApiCreatePageVerificationSchedule(props.page.id);
        $.post(url, {
            days, description, assignees, _token: window.csrfToken,
        })
            .then(({ verification_schedule }) => {
                setIsCreating(false);
                addSuccessMessage('Verification created!');
                return props.setVerificationScheduleIdAndClose(verification_schedule.id);
            });
    };

    const createButtonText = isCreating ? 'Loading...' : 'Add verification';
    const createButtonClass = isCreating ? 'is-disabled' : '';

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    Add verification to "
                    {props.page.title}
"
                </h2>
                <div className="form-group mb3">
                    <SelectVerificationAssignees onAssigneeSelect={handleAssigneeSelect} />
                    <label className="bold block col-12 mb1">How often should this page be verified? (days)</label>
                    <input
                        className="block col-3 mb2 field"
                        ref={daysInput}
                        defaultValue="90"
                        min="1"
                        max="365"
                        type="number"
                    />
                    <label className="bold block col-12 mb1">Add instructions to this verification (optional)</label>
                    <input
                        className="block col-12 mb2 field"
                        ref={descriptionInput}
                        placeholder="e.g Check page is up-to-date..."
                        type="text"
                    />
                </div>
                <div className="right-align mt2">
                    <span
                        className="btn-secondary mr1"
                        aria-label="Close"
                        role="button"
                        onClick={props.closeModal}
                    >
Cancel
                    </span>
                    <span
                        className={`btn btn-primary ${createButtonClass}`}
                        onClick={onClickCreate}
                    >
                        {createButtonText}
                    </span>
                </div>
            </div>
        </div>
    );
};

const UpdateVerificationScheduleModal = (props) => {
    const verificationList = useContext(VerificationListContext);
    const descriptionInput = useRef(null);
    const daysInput = useRef(null);
    const [isUpdating, setIsUpdating] = useState(false);
    const [assignees, setAssignees] = useState(false);
    const [verificationSchedule, setVerificationSchedule] = useState();
    const users = useUsers();
    const url = getApiGetVerificationAssigneesUrl(props.page.id);

    const assigneeIds = props.page.verification_schedule ? props.page.verification_schedule.verification_assignee.map(a => a.assignee_id) : [];
    const defaultAssignees = assigneeIds.length ? (users && users.filter(u => (assigneeIds.includes(u.id))).map(u => ({ label: u.display_name, value: u.id }))) : [];

    useEffect(() => {
        $.get(url)
            .then(({ assignees }) => {
                if (assignees) {
                    assignees = users && users.filter(u => (assignees.includes(u.id))).map(u => ({ label: u.display_name, value: u.id }));
                    setAssignees(assignees);
                }
            });
    }, [url, users]);

    useEffect(() => {
        const url = getApiPageVerificationSchedule(props.page.id, props.verificationScheduleId);
        $.get(url)
            .then(({ verification_schedule }) => {
                setVerificationSchedule(verification_schedule);
            });
    }, [props.verificationScheduleId]);

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };

    const handleAssigneeSelect = (list) => {
        setAssignees(list);
    };

    const onClickUpdate = () => {
        const description = descriptionInput.current.value;
        const days = daysInput.current.value;

        if (isUpdating || !days || parseInt(days) < 1) return;

        setIsUpdating(true);

        const url = getApiUpdatePageVerificationSchedule(props.page.id, props.verificationScheduleId);

        $.post({
            url,
            data: { days, description, assignees },
            type: 'PUT',
        }).done(({ verification_schedule }) => {
            setIsUpdating(false);
            addSuccessMessage('Verification updated!');
            if (verificationList) {
                const verifications = verificationList.verifications.map((v) => {
                    if (v.id === props.page.id && v.verification_schedule_id === props.verificationScheduleId) {
                        v.verification_schedule.verification_assignee = verification_schedule.verification_assignee;
                        v.verification_schedule.days = verification_schedule.days;
                        v.verification_schedule.description = verification_schedule.description;
                    }
                    return v;
                });
                verificationList.setVerifications(verifications);
            }
            return props.closeModal();
        });
    };

    const updateButtonText = isUpdating ? 'Loading...' : 'Edit verification';
    const updateButtonClass = isUpdating ? 'is-disabled' : '';

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    Edit verification "
                    {props.page.title}
"
                </h2>
                <div className="form-group mb3">
                    <SelectVerificationAssignees verificationScheduleId={props.verificationScheduleId} assignees={defaultAssignees} onAssigneeSelect={handleAssigneeSelect} />
                    <label className="bold block col-12 mb1">How often should this page be verified? (days)</label>
                    {!verificationSchedule
                        ? (<span className="loading grey">Loading</span>)
                        : (
                            <input
                                className="block col-3 mb2 field"
                                ref={daysInput}
                                defaultValue={verificationSchedule.days}
                                min="1"
                                max="365"
                                type="number"
                            />
                        )}
                    <label className="bold block col-12 mb1">Add instructions to this verification (optional)</label>
                    {!verificationSchedule
                        ? (<span className="loading grey">Loading</span>)
                        : (
                            <input
                                className="block col-12 mb2 field"
                                ref={descriptionInput}
                                placeholder="e.g Check page is up-to-date..."
                                type="text"
                                defaultValue={verificationSchedule.description}
                            />
                        )}
                </div>
                <div className="right-align mt2">
                    <span
                        className="btn-secondary mr1"
                        aria-label="Close"
                        role="button"
                        onClick={props.closeModal}
                    >
Cancel
                    </span>
                    <span
                        className={`btn btn-primary ${updateButtonClass}`}
                        onClick={onClickUpdate}
                    >
                        {updateButtonText}
                    </span>
                </div>
            </div>
        </div>
    );
};

const UpdateVerificationScheduleWrapper = (props) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <Fragment>
            <span className="link dropdown-option" onClick={() => setShowModal(true)}>Edit verification</span>
            {showModal && createPortal(<UpdateVerificationScheduleModal {...props} closeModal={() => setShowModal(false)} />, document.body)}
        </Fragment>
    );
};

const DeleteVerificationScheduleWrapper = (props) => {
    const verificationList = useContext(VerificationListContext);
    const { page, verificationScheduleId } = props;
    const [isDeleting, setIsDeleting] = useState(false);

    const deleteSchedule = () => {
        const url = getApiPageVerificationSchedule(page.id, verificationScheduleId);
        const type = 'DELETE';
        if (isDeleting) return;
        setIsDeleting(true);
        $.ajax({ url, type })
            .then(() => {
                setIsDeleting(false);
                addSuccessMessage('Verification deleted');
                if (verificationList) {
                    const verifications = verificationList.verifications.filter(v => v.verification_schedule_id !== verificationScheduleId && v.id !== page.id);
                    verificationList.setVerifications(verifications);
                }
            });
    };

    return (
        <span className="link dropdown-option red" onClick={deleteSchedule}>Remove verification</span>
    );
};

const CreateVerificationScheduleWrapper = (props) => (
    <Fragment>
        <span className="dropdown-option blue" onClick={() => props.setShowModal(true)}>Add verification</span>
        {props.showModal && createPortal(<CreateVerificationScheduleModal
            {...props}
            closeModal={() => props.setShowModal(false)}
        />, document.body)}
    </Fragment>
);

const LoadingViewVerificationScheduleModal = ({ title, closeModal }) => (
    <div className="react-modal open">
        <div className="modal-content p2">
            <h2>
                "
                {title}
" verification
            </h2>
            <div className="form-group mb3">
                <span className="loading grey">Loading verification details</span>
            </div>
            <div className="right-align mt2">
                <span className="btn-secondary mr1" aria-label="Close" role="button" onClick={closeModal}>Close</span>
            </div>
        </div>
    </div>
);

const ViewVerificationScheduleModal = (props) => {
    const [verificationSchedule, setVerificationSchedule] = useState();
    const [isDeleting, setIsDeleting] = useState(false);

    const { page, verificationScheduleId } = props;

    useEffect(() => {
        const url = getApiPageVerificationSchedule(page.id, verificationScheduleId);
        $.get(url)
            .then(({ verification_schedule }) => setVerificationSchedule(verification_schedule));
    }, [props.verificationScheduleId]);

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };

    const deleteSchedule = () => {
        const url = getApiPageVerificationSchedule(page.id, verificationScheduleId);
        const type = 'DELETE';
        if (isDeleting) return;
        setIsDeleting(true);
        $.ajax({ url, type })
            .then(() => {
                setIsDeleting(false);
                props.setVerificationScheduleId(null);
                addSuccessMessage('Verification deleted');
                return props.closeModal();
            });
    };

    if (!verificationSchedule) {
        return (
            <LoadingViewVerificationScheduleModal title={props.page.title} closeModal={props.closeModal} />);
    }

    const {
        user_id, days, description, last_verified_at, created_at,
    } = verificationSchedule;
    const deleteButtonText = isDeleting ? 'Deleting...' : 'Delete verification';
    const deleteButtonClass = isDeleting ? 'is-disabled' : '';

    const LastVerifiedText = !last_verified_at ? 'Not verified yet' : moment.utc(last_verified_at).local().fromNow();
    const DueText = !last_verified_at ? 'Now' : moment.utc(last_verified_at).local().startOf('day').add(days, 'days')
        .format('ll');

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    "
                    {props.page.title}
" verification
                </h2>
                <div className="form-group mb3">
                    <VerificationAssignee page={page} />
                    {description && (
                        <div className="mb2">
                            <span className="bold block col-12 mt2">Instructions</span>
                            <span className="col-12 mb2">{description}</span>
                        </div>
                    )}
                    <div className="flex">
                        <div className="flex-auto">
                            <span className="bold block col-12">Verification period</span>
                            <span className="col-12">
                                {`Every ${pluralText(days, 'day')}`}
                            </span>
                        </div>
                        <div className="flex-auto">
                            <span className="bold block col-12">Last verified</span>
                            <span className="col-12">{LastVerifiedText}</span>
                        </div>
                    </div>
                    <span className="bold block col-12 mt2">Due</span>
                    <span className="col-12">{DueText}</span>
                    <VerificationCreator user_id={user_id} created_at={created_at} />
                </div>
                <div className="right-align mt2">
                    {canDeleteVerificationSchedule() && !props.verifiedPage
                    && (
                        <span
                            className={`btn btn-delete mr1 ${deleteButtonClass}`}
                            aria-label="Delete"
                            role="button"
                            onClick={deleteSchedule}
                        >
                            {deleteButtonText}
                        </span>
                    )}
                    <span
                        className="btn-secondary"
                        aria-label="Close"
                        role="button"
                        onClick={props.closeModal}
                    >
Close
                    </span>
                </div>
            </div>
        </div>
    );
};

const ViewVerificationScheduleWrapper = (props) => (
    <Fragment>
        <span className="dropdown-option blue view-verification" onClick={() => props.setShowModal(true)}>View verification</span>
        {props.showModal && createPortal(
            <ViewVerificationScheduleModal {...props} closeModal={() => props.setShowModal(false)} />,
            document.body,
        )}
    </Fragment>
);

const UpgradeSubscriptionModal = (props) => {
    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    "
                    {props.page.title}
" verification
                </h2>
                <div className="form-group mb2">
                    <div className="mt2">
                        <p>Your subscription doesn't include page verification.</p>
                        <Tippy content="Upgrade to use page verification">
                            <a
                                href={getUpgradePlanUrl()}
                                className="btn-tertiary ml1 btn-teal upgrade-button"
                            >
                                Upgrade
                            </a>
                        </Tippy>
                    </div>
                </div>
                <div className="right-align mt2">
                    <span
                        className="btn-secondary"
                        aria-label="Close"
                        role="button"
                        onClick={props.closeModal}
                    >
Close
                    </span>
                </div>
            </div>
        </div>
    );
};

const UpgradeSubscriptionModalWrapper = (props) => (
    <Fragment>
        <span className="dropdown-option blue" onClick={() => props.setShowModal(true)}>Add verification</span>
        {props.showModal && createPortal(<UpgradeSubscriptionModal
            {...props}
            closeModal={() => props.setShowModal(false)}
        />, document.body)}
    </Fragment>
);

const showModalFromUrlParams = () => {
    const params = getParamsFromSearchURL(window.location.search);
    const { showVerificationModal = false } = params;

    return showVerificationModal;
};

const VerificationScheduleWrapper = (props) => {
    // To handle page list dropdowns, where this is no page context
    const { page: pageFromContext, setPage } = useContext(PageContext) || {};
    const showModalFromParams = showModalFromUrlParams();
    const [showModal, setShowModal] = useState(showModalFromParams);
    const [verificationScheduleId, setVerificationScheduleId] = useState(props.page.verification_schedule_id);

    const setPageVerificationId = (id) => {
        if (!pageFromContext || !setPage) return;
        return setPage({
            ...pageFromContext,
            verification_schedule_id: id,
            needs_verification: !!id,
        });
    };

    if (!hasVerificationFeature()) {
        return <UpgradeSubscriptionModalWrapper {...props} setShowModal={setShowModal} showModal={showModal} />;
    }

    if (verificationScheduleId && canViewVerificationSchedule()) {
        return (
            <Fragment>
                <ViewVerificationScheduleWrapper
                    {...props}
                    verificationScheduleId={verificationScheduleId}
                    setVerificationScheduleId={(id) => {
                        setVerificationScheduleId(id);
                        setPageVerificationId(id);
                    }}
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
                {canUpdateVerificationSchedule() && props.verifiedPage
                && <UpdateVerificationScheduleWrapper {...props} verificationScheduleId={verificationScheduleId} />}
                {canDeleteVerificationSchedule() && props.verifiedPage
                && <DeleteVerificationScheduleWrapper {...props} verificationScheduleId={verificationScheduleId} />}
            </Fragment>
        );
    }

    if (!canCreateVerificationSchedule()) return null;

    return (
        <CreateVerificationScheduleWrapper
            {...props}
            setVerificationScheduleIdAndClose={(id) => {
                setShowModal(false);
                setVerificationScheduleId(id);
                setPageVerificationId(id);
            }}
            showModal={showModal}
            setShowModal={setShowModal}
        />
    );
};

export { LoadingViewVerificationScheduleModal };

export { VerificationCreator };

export { SelectVerificationAssignees };

export default VerificationScheduleWrapper;
